import { Columns3 } from 'lucide-react';

import {
  Button,
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@shigo-ui/ui';

export interface DashboardDataTableColumnOption {
  id: string;
  label: string;
  locked?: boolean | undefined;
}

export interface DashboardDataTableColumnChooserProps {
  ariaLabel: string;
  columns: readonly DashboardDataTableColumnOption[];
  hidden: ReadonlySet<string>;
  onToggle: (id: string, visible: boolean) => void;
  onReset?: (() => void) | undefined;
  resetLabel?: string | undefined;
}

export function DashboardDataTableColumnChooser({
  ariaLabel,
  columns,
  hidden,
  onToggle,
  onReset,
  resetLabel = 'Reset',
}: DashboardDataTableColumnChooserProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button type="button" variant="outline" size="icon" aria-label={ariaLabel}>
          <Columns3 className="h-4 w-4" aria-hidden="true" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52">
        {columns.map((column) => (
          <DropdownMenuCheckboxItem
            key={column.id}
            checked={column.locked ? true : !hidden.has(column.id)}
            disabled={Boolean(column.locked)}
            onSelect={(event) => {
              event.preventDefault();
            }}
            onCheckedChange={(visible) => {
              onToggle(column.id, visible);
            }}
          >
            <span className="truncate">{column.label}</span>
          </DropdownMenuCheckboxItem>
        ))}
        {onReset ? (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              className="cursor-pointer justify-center text-center"
              onSelect={onReset}
            >
              {resetLabel}
            </DropdownMenuItem>
          </>
        ) : null}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
